module.exports = __webpack_public_path__ + "static/img/gongdan.48565ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/gongdan.png
// module id = TERh
// module chunks = 19